export default __webpack_public_path__ + "static/media/overviewIcon.57998b38.svg";